<div class="mt-field">
  <quill-editor [(ngModel)]="content" [modules]="modules" [placeholder]="placeholder"></quill-editor>
  <ng-content></ng-content>
</div>
<p class="mt-hint">{{hint}}</p>
